import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Mail, ArrowRight, ShieldCheck } from "lucide-react";
import { useAuth } from "../authApi";
import { LOGO_URL } from "../api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const nextUrl = searchParams.get("next") || "/mon-compte";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav(nextUrl); }
    catch (ex) { setErr(ex.message || "Connexion impossible"); }
    finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + nextUrl;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const inputCls = "w-full bg-white/5 border border-white/10 px-11 py-3 text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-[#C19A6B] transition-colors";

  return (
    <div className="platform-scope min-h-screen bg-[#050505] text-white flex items-center justify-center px-6" style={{ fontFamily: "'Outfit', sans-serif" }}>
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><img src={LOGO_URL} alt="OFF MARKETTE" className="w-[220px] h-auto" /></Link>
        <div className="bg-[#0d0d10] border border-white/10 p-8 space-y-6">
          <div className="text-center space-y-1">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#C19A6B]"><ShieldCheck className="w-4 h-4" /> Back-office</span>
            <h1 className="text-2xl font-light">Espace administrateur</h1>
          </div>

          {err && <div data-testid="login-error" className="bg-red-500/10 border border-red-500/30 text-red-300 text-sm px-4 py-3">{err}</div>}

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div className="relative">
              <Mail className="w-4 h-4 text-[#C19A6B] absolute left-4 top-1/2 -translate-y-1/2" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email" className={inputCls} />
            </div>
            <div className="relative">
              <Lock className="w-4 h-4 text-[#C19A6B] absolute left-4 top-1/2 -translate-y-1/2" />
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" data-testid="login-password" className={inputCls} />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit" className="w-full flex items-center justify-center gap-2 bg-[#C19A6B] hover:bg-[#d1af84] text-white font-medium uppercase tracking-wider text-sm py-3.5 transition-colors disabled:opacity-60">
              {loading ? "Connexion…" : <>Se connecter <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>

          <div className="flex items-center gap-3 text-xs text-zinc-500"><div className="flex-1 h-px bg-white/10" /> ou <div className="flex-1 h-px bg-white/10" /></div>

          <button onClick={googleLogin} data-testid="login-google" className="w-full flex items-center justify-center gap-3 bg-white text-[#1a1a1a] font-medium text-sm py-3 hover:bg-zinc-200 transition-colors">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> Continuer avec Google
          </button>
        </div>
        <Link to="/" className="block text-center text-xs text-zinc-500 hover:text-white mt-6 uppercase tracking-wider">← Retour au site</Link>
      </motion.div>
    </div>
  );
}
